import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';
import AllPlansImage from './AllPlansImage';

export default function Statement() {
  const { i18n } = useTranslation();
  const { token, user } = useAuth();
  const isRTL = i18n.language === 'ar';
  if (!user?.client_id) {
    return <div className="py-16 text-center text-slate-400 text-sm" data-testid="statement-no-client">{isRTL ? 'هذا الحساب غير مرتبط بعميل' : 'This account is not linked to a client'}</div>;
  }
  return (
    <div data-testid="client-statement-page">
      <AllPlansImage isRTL={isRTL} plans={[]} headers={{ Authorization: `Bearer ${token}` }} isAdmin={false} fixedClientId={user.client_id} />
    </div>
  );
}
